module.exports = __webpack_public_path__ + "bichat-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/bichat-2.jpg
// module id = 1858
// module chunks = 0